import { LandingPage } from 'pageModules/LandingPage';

export default LandingPage;
